module.exports = __webpack_public_path__ + "media/images/flags/32/Benin-9beb96dcd2332f00527c7812bb3b02f6.png";